"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MessageStreams;

var _react = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var _BriefsHelperMessage = _interopRequireDefault(require("../../components/CampaignCreator/BriefsHelperMessage"));

var _BriefsHelperButton = _interopRequireDefault(require("../../components/CampaignCreator/BriefsHelperButton"));

var _StreamFilters = _interopRequireDefault(require("../../components/CampaignCreator/MessageStreams/StreamFilters"));

var _StreamsSelection = _interopRequireDefault(require("../../components/CampaignCreator/MessageStreams/StreamsSelection"));

var _CreativeBriefs = _interopRequireDefault(require("../../components/CampaignCreator/MessageStreams/CreativeBriefs"));

var _actions = require("../../actions");

var _loadUniverses = require("../../actions/campaignCreator/universes/loadUniverses");

var _setUniverse = require("../../actions/campaignCreator/universes/setUniverse");

var _helpers = require("../../../helpers");

var _useFeatureAccessHook = require("../../helpers/useFeatureAccessHook");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var helperMessage = /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, "The system has analysed the Helix Personas you have either selected or uploaded, and determined the appropriate messaging."), /*#__PURE__*/_react["default"].createElement("p", null, "The first section below lists the defined target audience. this is either the selected list of Personas, or those Personas which are over-represented in your distribution. In the latter case, you can choose the threshold for over-representation by setting an index value. An index of 110 means at least 10% more likely to appear within your distribution."), /*#__PURE__*/_react["default"].createElement("p", null, "The second section lists the messaging streams that have been created, for your defined Audience. Where a single message is not appropriate, multiple streams are shown, and the proportion of the audience to which each stream applies. You can choose any or all of the messaging streams, depending on your budget or ability to customise the creative. As a rule of thumb, we suggest you use as many messaging streams as required to reach at least two-thirds (66%) of the target audience."), /*#__PURE__*/_react["default"].createElement("p", null, "The third section contains the messaging content. Each messaging stream has its own unique creative brief which you can now view or download."));

function MessageStreams(props) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var backRef = (0, _react.useRef)(null);
  var holdWidth = 73;

  if (backRef.current && backRef.current.ref && backRef.current.ref.current) {
    holdWidth = backRef.current.ref.current.clientWidth;
  }

  var campaignWorkflowPermission = (0, _reactRedux.useSelector)(function (state) {
    return state.options.permissions.workflowPermission;
  });
  var campaignCreatorAccess = (0, _useFeatureAccessHook.useFeatureAccess)(campaignWorkflowPermission);

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return state.campaignCreator;
  }),
      briefsFlow = _useSelector.briefsFlow;

  var previewSelectedPersonas = (0, _reactRedux.useSelector)(function (state) {
    return state.campaignCreator.previewSelectedPersonas;
  });
  var helperPage = 'message'; // setting index state, if in find personas flow then check if there is an existing
  // value in state and use that, otherwise default to 110

  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
    return state.messageStreams;
  }),
      threshold = _useSelector2.threshold;

  var _useState = (0, _react.useState)(briefsFlow === 'find' ? threshold !== null || threshold !== 0 ? threshold : 110 : 0),
      indexThreshold = _useState[0],
      setIndexThreshold = _useState[1];

  var selectedPersonas = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedPersonas.personas;
  });

  var _useSelector3 = (0, _reactRedux.useSelector)(function (state) {
    return state.quadrants;
  }),
      quadrants = _useSelector3.quadrants;

  var _useSelector4 = (0, _reactRedux.useSelector)(function (state) {
    return state.universes;
  }),
      universes = _useSelector4.results,
      currentUniverse = _useSelector4.currentUniverse,
      isFetching = _useSelector4.isFetching;

  (0, _react.useEffect)(function () {
    if (selectedPersonas.length) {
      dispatch((0, _actions.getQuadrants)(indexThreshold, currentUniverse));
    }
  }, [dispatch, indexThreshold, selectedPersonas, currentUniverse]); // used to set threshold in state for use on deliver campaign page if a different
  // quadrant is selected, only used to set indexThreshold state on mounting

  (0, _react.useEffect)(function () {
    dispatch((0, _actions.setIndexThreshold)(indexThreshold));
  }, [dispatch, indexThreshold]);
  var backLocation = briefsFlow === 'find' ? // TODO: should this go back to dist or original?
  previewSelectedPersonas ? 'personas-distribution' : 'find-personas' : briefsFlow === 'select' ? 'select-personas' : null; // Back button only works if it leads you to persona selection screen

  var BackButton = backLocation ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    ref: backRef,
    as: _reactRouterDom.Link,
    to: backLocation
  }, "Back") : /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    ref: backRef,
    disabled: true
  }, "Back");
  var NextButton = (0, _helpers.isNZHelix)() ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: holdWidth
    }
  }) : /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    className: "ui button",
    to: "deliver-campaign"
  }, "Next");
  (0, _react.useEffect)(function () {
    dispatch((0, _loadUniverses.loadUniverses)());
  }, [dispatch]);
  var universeMap = universes.map(function (universe) {
    return {
      value: universe.universeId,
      text: universe.universeLabel
    };
  });

  var changeTheUniverse = function changeTheUniverse(universeId) {
    dispatch((0, _setUniverse.setUniverse)(universeId));
  };

  var _useLocation = (0, _reactRouterDom.useLocation)(),
      search = _useLocation.search;

  (0, _react.useEffect)(function () {
    var params = new URLSearchParams(search);
    var personaIds = params.get('personaIds');
    var personaShares = params.get('personaShares');
    var universeId = params.get('universeId');

    if (personaIds) {
      var personaIdArray = personaIds.split(',').map(function (id) {
        return {
          id: Number(id)
        };
      });
      dispatch((0, _actions.setBriefsFlow)('select'));
      dispatch((0, _actions.setSelectedPersonas)(personaIdArray));
    } else if (personaShares) {
      var personaShareArray = personaShares.split(',').map(function (persona) {
        var _persona$split = persona.split(':'),
            id = _persona$split[0],
            share = _persona$split[1];

        return {
          id: Number(id),
          value: parseFloat(share)
        };
      });
      dispatch((0, _actions.setBriefsFlow)('find'));
      dispatch((0, _actions.setSelectedPersonas)(personaShareArray));
    }

    if (universeId) {
      dispatch((0, _setUniverse.setUniverse)(Number(universeId)));
    }
  }, [dispatch, search]);
  return campaignCreatorAccess ? /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Container, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, {
    style: {
      paddingBottom: 0
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "creative-briefs--navigation creative-briefs--navigation__x-pad"
  }, BackButton, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "campaign-creator--title"
  }, "Messaging"), /*#__PURE__*/_react["default"].createElement(_BriefsHelperButton["default"], {
    page: helperPage
  })), NextButton))), /*#__PURE__*/_react["default"].createElement(_BriefsHelperMessage["default"], {
    page: helperPage,
    message: helperMessage
  })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
    className: "message-streams--container"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    computer: 7
  }, /*#__PURE__*/_react["default"].createElement(_StreamFilters["default"], {
    indexFilter: indexThreshold,
    setIndexFilter: setIndexThreshold,
    isSimple: briefsFlow === 'select' ? true : false
  })), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    computer: 5,
    style: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'flex-end'
    },
    className: "creative-briefs--universe-wrapper"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Dropdown, {
    className: "creative-briefs--universe",
    value: currentUniverse,
    options: universeMap,
    direction: "left",
    placeholder: "Total Audience",
    loading: isFetching,
    onChange: function onChange(event, data) {
      changeTheUniverse(data.value);
    }
  }))), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    mobile: 12,
    computer: 5
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "creative-briefs__header-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("h2", null, "2. Select Message Streams"), /*#__PURE__*/_react["default"].createElement("h5", {
    className: "creative-briefs__download-header"
  }, "Download", /*#__PURE__*/_react["default"].createElement("br", null), " Creative Brief")), (quadrants === null || quadrants === void 0 ? void 0 : quadrants.length) ? /*#__PURE__*/_react["default"].createElement(_StreamsSelection["default"], {
    indexThreshold: indexThreshold
  }) : 'No Message Streams'), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
    mobile: 12,
    computer: 7
  }, /*#__PURE__*/_react["default"].createElement("h2", null, "3. View Creative Brief"), (quadrants === null || quadrants === void 0 ? void 0 : quadrants.length) ? /*#__PURE__*/_react["default"].createElement(_CreativeBriefs["default"], null) : '')), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, {
    style: {
      paddingTop: 0,
      paddingBottom: '12px'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "creative-briefs--navigation"
  }, BackButton, NextButton))))) : null;
}